<script setup>
    import Image from '@/components/Image.vue';

    defineProps(['step']);
    const emit = defineEmits(['select-option']);
</script>

<template>
    <p class="option-note-top" v-if="step.selected.value.topDescription">{{ step.selected.value.topDescription }}</p>
    <BButtonGroup class="btn-group big-icons config-tabs config-tabs--floating">
        <BButton
            v-for="(option, index) in step.options"
            :key="index"
            class="btn btn-md btn-secondary swatch-toggle__icon"
            :class="{ 'active': step.selected.value.id === option.id }"
            @click="emit('select-option', step, option)"
            :disabled="option.disabled && option.disabled.value"
        >
            <Image class="swatch-toggle__image swatch-toggle__image--l" :src="option.image" />
            <span class="swatch-toggle__label">{{ option.label }}</span>
        </BButton>
    </BButtonGroup>
    <p class="option-note" v-if="step.selected.value.note">{{ step.selected.value.note }}</p>
</template>